var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInfoManagement = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4.5 14.5h15v-10h-15zM19.5 2h-15A2.5 2.5 0 0 0 2 4.5v10A2.5 2.5 0 0 0 4.5 17h6.25v2.5h-2.5a1.25 1.25 0 0 0 0 2.5h7.5a1.25 1.25 0 0 0 0-2.5h-2.5V17h6.25a2.5 2.5 0 0 0 2.5-2.5v-10A2.5 2.5 0 0 0 19.5 2"
})));
export default SvgInfoManagement;